export default __webpack_public_path__ + "static/media/techopedia_logo.4a869300.svg";